import React, { Component } from 'react';
import { connect } from 'react-redux';

class Footer extends Component {
	render() {
		return (
			<footer className="mastfoot py-4 mt-auto text-center">
				<h1 className="sr-only visually-hidden">Assist@: Footer</h1>
				<div className="container-fluid mastfoot-container">
					<nav className="nav align-items-center">
						<a className="nav-link" target="blank" href="mailto:contact@assistarobase.fr">Contact</a>
					</nav>
				</div>
			</footer>
		)
	}
}

const mapStateToProps = (state) => ({
	example: state.example,
});
const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
